import {
    CheckCircleFilled,
    FilePdfOutlined,
    MailOutlined
} from '@ant-design/icons';
import { Button, List, Popconfirm, Popover, Space, Tag, Tooltip } from 'antd';
export const RegistrantsColumns = [
    {
        title: 'Name',
        dataIndex: 'name',
    },
    {
        title: 'Achievement',
        dataIndex: 'achievement',
    },
    {
        title: 'Category',
        dataIndex: 'category',
    },
    {
        title: 'City',
        dataIndex: 'city',
    },
    {
        title: 'Teacher',
        dataIndex: 'teacher',
    },
    {
        title: 'Duration',
        dataIndex: 'duration',
    },
];

export const getRegistrants2025Columns = (getScoreData, getAgeCategoryLabel, handleDownloadPDF, handleUpdateStatus, showEditModal, handleDelete, deletingId, handleViewVideo, handleOpenUploadModal, showManageScoreModal, handleResendEmail, resendingId) => [
    { title: "Parent Name", dataIndex: "name" },
    { title: "Teacher Name", dataIndex: "teacherName" },
    { title: "Total Performer", dataIndex: "totalPerformer" },
    { title: "Competition Category", dataIndex: "competitionCategory" },
    { title: "Performance Category", dataIndex: "PerformanceCategory" },
    { title: "User Type", dataIndex: "userType" },
    { title: "Payment Status", dataIndex: "paymentStatus" },
    // { title: "Birth Cert", dataIndex: "birthCertS3Link" },
    {
        title: "Performers",
        dataIndex: "performers",
        render: (performers) => {
            if (Array.isArray(performers)) {
                return performers.map((p, i) => (
                    p.firstName ? (
                        <div key={i}>{i + 1}. {p.firstName} {p.lastName}</div>
                    ) : (
                        <div key={i}>{i + 1}. {p.fullName}</div>
                    )
                ));
            }
            return "-";
        },
    },
    {
        title: "Performers Email",
        dataIndex: "performers",
        render: (performers) => {
            if (Array.isArray(performers)) {
                return performers.map((p, i) => (
                    <div key={i}>{i + 1}. {p.email}</div>
                ));
            }
            return "-";
        },
    },
    { title: "YouTube Link", dataIndex: "youtubeLink" },
    {
        title: "Age Category", dataIndex: "ageCategory", render: (ageCategory) => {


            return getAgeCategoryLabel(ageCategory, "", "");
        },
    },
    { title: "Instrument Category", dataIndex: "instrumentCategory" },
    {
        title: "Created At", dataIndex: "createdAt",
        sorter: (a, b) => {
            const timeA = a.createdAt?.seconds || 0;
            const timeB = b.createdAt?.seconds || 0;
            return timeA - timeB;
        },
        render: (createdAt) => {
            if (createdAt?.seconds) {
                const date = new Date(createdAt.seconds * 1000);
                return date.toLocaleString();
            }
            return "-";
        },
    },

    { title: "Remark", dataIndex: "remark" },
    {
        title: 'Actions',
        key: 'actions',
        // The render function now calls the handlers passed as arguments
        render: (text, record) => (
            <div>
                <Button type="link" onClick={() => handleDownloadPDF(record)}>
                    Download PDF
                </Button>

                <Button type="primary" onClick={() => handleUpdateStatus(record)}>
                    Mark as Paid
                </Button>
            </div>
        ),
    },
    {
        title: 'Actions',
        key: 'actions',
        render: (_, record) => (
            <Space size="middle">
                <Button type="link" onClick={() => showEditModal(record)}>
                    Edit
                </Button>

                <Popconfirm
                    title="Delete the registrant"
                    description="Are you sure you want to delete this registrant? This action cannot be undone."
                    onConfirm={() => handleDelete(record.id)}
                    okText="Yes, Delete"
                    cancelText="No"
                >
                    <Button
                        type="link"
                        danger // This makes the button text red
                        loading={deletingId === record.id} // Show spinner only on the clicked button
                    >
                        Delete
                    </Button>
                </Popconfirm>
                <Button type="link" onClick={() => showManageScoreModal(record)}>
                    Manage Score
                </Button>
                <Tooltip title="Resend registration confirmation email">
                    <Button
                        type="link"
                        icon={<MailOutlined />}
                        loading={resendingId === record.id}
                        onClick={() => handleResendEmail(record)}
                        style={{ color: '#1890ff' }}
                    >
                        Resend Email
                    </Button>
                </Tooltip>
            </Space>
        ),
    },
    {
        title: "Performance Video",
        key: "video",
        render: (_, record) => {
            // Check if there is a YouTube link OR an S3 video file
            const hasVideo = record.youtubeLink || record.videoPerformanceS3Link;

            if (!hasVideo) return "-";

            return (
                <Button
                    type="primary"
                    ghost
                    size="small"
                    onClick={() => handleViewVideo(record)}
                >
                    Play Video
                </Button>
            );
        },
    },
    {
        title: 'Jury Files',
        key: 'jury_files',
        align: 'center',
        render: (_, record) => (
            <Space>
                <Tooltip title="Upload Certificate/Comment Sheet">
                    <Button
                        size="small"
                        type="primary"
                        ghost
                        icon={<FilePdfOutlined />}
                        onClick={() => handleOpenUploadModal(record)}
                    />
                </Tooltip>
                {/* You could add indicators here if files already exist */}
                {record.certificateS3Link && <Tag color="gold">Cert</Tag>}
            </Space>
        )
    },
    {
        title: 'Avg Score',
        key: 'score',
        width: 120,
        align: 'center',
        sorter: (a, b) => parseFloat(a.avg) - parseFloat(b.avg),
        render: (_, record) => {
            const { avg, details } = getScoreData(record.id);

            if (avg === '-') return <Tag>N/A</Tag>;

            // Content for the Popover (Individual Jury Breakdown)
            const content = (
                <List
                    size="small"
                    dataSource={details}
                    renderItem={item => {
                        const hasAdminAdjusted = item.adminAdjustedScore !== null && item.adminAdjustedScore !== undefined;
                        return (
                            <List.Item>
                                <div>
                                    <strong>{item.juryName}:</strong> {hasAdminAdjusted ? `${item.adminAdjustedScore} (Original: ${item.score})` : item.score}
                                    {item.comment && <div style={{ fontSize: '10px', color: '#888', maxWidth: '200px' }}>"{item.comment}"</div>}
                                    {item.panelComment && <div style={{ fontSize: '10px', color: '#aaa', maxWidth: '200px', fontStyle: 'italic' }}>Panel note: "{item.panelComment}"</div>}
                                </div>
                            </List.Item>
                        );
                    }}
                />
            );

            return (
                <Popover content={content} title="Jury Breakdown" trigger="hover">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                        <Tag
                            color={record.isScoreFinalized ? "#52c41a" : "#faad14"}
                            style={{
                                fontSize: '14px',
                                fontWeight: '800',
                                cursor: 'pointer',
                                margin: 0,
                                padding: '4px 10px',
                                borderRadius: '6px',
                                border: record.isScoreFinalized ? '1px solid #b7eb8f' : '1px solid #ffe58f',
                                boxShadow: record.isScoreFinalized ? '0 2px 0 rgba(82, 196, 26, 0.1)' : '0 2px 0 rgba(250, 173, 20, 0.1)'
                            }}
                        >
                            {record.averageScore ? Number(record.averageScore).toFixed(2) : avg}
                        </Tag>
                        {record.isScoreFinalized && (
                            <Tooltip title="Score Finalized & Locked">
                                <Tag color="success" icon={<CheckCircleFilled />} style={{ margin: 0, fontSize: '10px', borderRadius: '4px' }}>
                                    FINAL
                                </Tag>
                            </Tooltip>
                        )}
                    </div>
                </Popover>
            );
        }
    },
    {
        title: 'Result',
        key: 'finalAward',
        width: 120,
        align: 'center',
        render: (_, record) => {
            // Prefer value from DB
            if (record.finalAward) {
                let color = 'default';
                const award = String(record.finalAward).toLowerCase();
                if (award.includes('sapphire')) color = 'purple';
                else if (award.includes('diamond')) color = 'cyan';
                else if (award.includes('gold')) color = 'gold';
                else if (award.includes('silver')) color = 'geekblue';
                else if (award.includes('bronze')) color = 'orange';

                return (
                    <Space direction="vertical" size={2} style={{ display: 'flex', alignItems: 'center' }}>
                        <Tag color={color} style={{ fontWeight: 700, borderRadius: '4px', textTransform: 'uppercase', margin: 0 }}>
                            {record.finalAward}
                        </Tag>
                        {record.isScoreFinalized && (
                            <div style={{ fontSize: '10px', color: '#52c41a', display: 'flex', alignItems: 'center', gap: '2px', marginTop: '2px' }}>
                                <CheckCircleFilled style={{ fontSize: '10px' }} /> VERIFIED
                            </div>
                        )}
                    </Space>
                );
            }
            return <Tag>-</Tag>;
        }
    },
];